import { StyleSheet } from 'react-native';

import { widthPercentageToDP } from 'utils/responsiveness';

const styles = StyleSheet.create({
    container: {
        minHeight: widthPercentageToDP(48),
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'flex-start',
    },
    rightContainer: {
        marginLeft: 'auto',
        maxWidth: '50%',
    },
    icon: {
        marginRight: widthPercentageToDP(16),
    },
    wrapperContent: {
        flexDirection: 'column',
        justifyContent: 'center',
    },
    rightImage: {
        width: widthPercentageToDP(24),
        height: 24,
        marginRight: widthPercentageToDP(2),
    },
});

export default styles;
